import * as React from "react";
import {Component} from "react";
import styles from "../styles/wizards/AddRoomTypeWizard.scss";
import autobind from "autobind-decorator";
import AddRoomTypeIcon from "../assets/images/add-room-type-64x64.svg";
import {__, mapStateToProps, setTableParams, validateForm} from "../core/utils";
import {withRouter} from "react-router";
import {getStagesLanguages} from "../redux/actions/table/stages";
import {setNotification} from "../redux/actions/general/notification";
import {createRoomType, listRoomTypes} from "../redux/actions/table/room_types";
import AddRoomTypeForm from "../forms/add_room_type_wizard/AddRoomTypeForm";

@withRouter
@mapStateToProps(state => ({
	table: state.table["room_types"],
}))
class AddRoomTypeWizard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			project_languages: null
		}
	}

	componentDidMount() {
		getStagesLanguages(this.props.match.params.stage).then(({response}) => {
			this.setState({project_languages: response.data});
		});
	}

	@autobind
	_handleSubmit(formData) {
		const {edit} = formData;

		formData = _.omit(formData, ['edit']);

		return validateForm(
			createRoomType(this.props.match.params.stage, formData).then(({response}) => {
				listRoomTypes(this.props.match.params.stage).then(() => {
					if(edit) {
						setTableParams('room_types', {
							clicked_row: response.data.id
						});
					}
				});

				setTableParams('room_types', {
					actioned_row: undefined,
					selected_rows: []
				});

				this.props.onClose();

				setNotification(__("wizard.add-room-type.message.success"));
			})
		);
	}

	render() {
		return (
			<>
				<div className={styles.header}>
					<div className={styles.left}>
						<span>{__('wizard.add-room-type.title.add-new-room-type')}</span>
						<span>{__('wizard.add-room-type.subtitle.add-new-room-type')}</span>
					</div>
					<div className={styles.right}>
						<AddRoomTypeIcon />
					</div>
				</div>
				<div className={styles.body}>
					{this.state.project_languages && <AddRoomTypeForm
						projectLanguages={this.state.project_languages}
						onSubmit={this._handleSubmit}
						initialValues={{
							title: {},
							description: {},
						}}
					/>}
				</div>
			</>
		);
	}
}

export default AddRoomTypeWizard;